<template lang="pug">
	section.section.main-section
		.container.container-narrow
			title-comp(:name="$t('title.company_codes')")

			article.message.is-warning(v-if="emptyPage || (!errorPage && Array.isArray(codes) && codes.length === 0)")
				.message-body
					| {{ $t('codes.empty') }}

			article.message.is-danger(v-else-if="errorPage")
				.message-body
					| {{ $t('alert.error') }}

			hourglass(v-if="refreshing")

			.margin-top-md(v-for="code in codes" :key="code.code" v-else)
				article.message.invite-code-block
					.message-body.code-body
						.columns.is-centered.is-mobile
							.column.is-narrow.is-centered.is-vcentered.code-column
								strong.is-size-4-desktop {{ code.code }}
							.column.is-vcentered
								.is-size-5-desktop
									p
										.dot-circle
										| {{ $t('codes.received_on', { date: getDate(code.timestamp, true) }) }}
									p
										.dot-circle
										| {{ $t('codes.expires_on', { date: getDate(code.expiration, true) }) }}
									p
										.dot-circle
										| {{ code.users && code.users.length > 0 ? $t('codes.valid_for_usage', { max: code.limit, current: code.users.length }) : $t('codes.valid_for', { max: code.limit }) }}

				code-messages-comp(:code="code")

			.margin-top-md.has-text-centered(v-if="!refreshing")
				button.button.is-primary.button-right-icon(type="button" @click="resetAndLoad")
					| {{ $t('button.update') }}
					span.icon.feather
						refresh-cw-icon



</template>

<script>
import HourglassComponent from '../components/HourglassComponent.vue'
import TitleComponent from '../components/TitleComponent.vue'
import CodeMessagesComponent from '../components/CodeMessagesComponent.vue'
import { RefreshCwIcon } from 'vue-feather-icons'
import { clearTimeout } from 'timers';

export default {
	components: {
		Hourglass: HourglassComponent,
		TitleComp: TitleComponent,
		CodeMessagesComp: CodeMessagesComponent,
		RefreshCwIcon
	},
	data() {
		return {
			refreshing    : false,
			emptyPage     : false,
			errorPage     : false,
			timeoutRefresh: null
		}
	},
	computed: {
		accessToken() {
			return this.$store.state.auth.accessToken
		},
		loading() {
			return this.$store.state.invitecode.loading
		},
		codes() {
			return this.$store.state.invitecode.codes
		}
	},
	mounted() {
		//this.$meta().setOptions({ title: this.$t("title.company_codes") + ' | ' + this.$t("title.home") })
		if (this.codes.length === 0) {
			this.resetAndLoad()
		}
	},
	beforeUnmount() {
		clearTimeout(this.timeoutRefresh)
	},
	methods: {
		resetAndLoad() {
			this.refreshing = true
			this.$store.dispatch('invitecode/getInviteCodes', this.accessToken).then(() => {
				this.emptyPage = false
				this.errorPage = false
				this.$nextTick(() => {
					this.stopRefreshing()
				})
			}).catch(err => {
				if (err.response && err.response.status) {
					switch (err.response.status) {
						case 403:
							if (err.response.data && err.response.data.error_message === 'Access Token Expired') {
								this.$store.dispatch('auth/clearToken').then(() => {
									if (this.$route.params.language) {
										this.$router.replace('/' + this.$route.params.language + '/login')
										return
									}

									this.$router.replace('/login')
								})
							}
							break
						case 404:
							this.emptyPage = true
							break
						case 500:
							this.errorPage = true
							break
						default:
							console.warn(err.response.status)
					}
				}
				this.$nextTick(() => {
					this.stopRefreshing()
				})
			})
		},
		stopRefreshing() {
			this.timeoutRefresh = setTimeout(() => { this.refreshing = false }, 1400)
		},
		getDate(p, withYear) {
			const d = typeof p === 'number' ? new Date(p * 1000) : new Date()
			const months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec']
			const month = months[d.getMonth()]

			return d.getDate() + ' ' + this.$t('time.month.' + month) + (withYear ? ' ' + d.getFullYear() : '')
		}
	}
}
</script>

<style lang="stylus" scoped>
	.dot-circle
		margin-top -0.3rem
		margin-right 0.5rem
		margin-left 0.2rem
		vertical-align middle
		width .6rem
		height .6rem
		background-color #ff8232
		border-radius 100%
		display inline-block
	.code-column
		background-color #FFF
		border-radius 1rem
		min-width 9rem
		min-height 9rem

		strong
			width 100%
			text-align center
			font-style italic

	.message-body.code-body
		padding 1.5em 1.5em
</style>
